import React, { useEffect, useState } from "react";
import * as uuid from 'uuid';

import styles from "../../../../../../styles/add-product.module.scss";
import { Button } from "../../../../../components/Button";
import { Checkbox } from "../../../../../components/Checkbox";
import { CurrencyInput } from "../../../../../components/CurrencyInput";
import { Hairline } from "../../../../../components/Hairline";
import { Input } from "../../../../../components/Input";
import { Label } from "../../../../../components/Label";
import { NumberInput } from "../../../../../components/NumberInput";
import { Select } from "../../../../../components/Select";
import { Icon } from "../../../../../components/core/Icon";

const PackageType = {
    COPO: "COPO",
    GALAO: "GALAO",
    GARRAFA: "GARRAFA",
    JARRA: "JARRA",
    LATA: "LATA",
    LONGNECK: "LONGNECK",
    OTHER: "OTHER"
}

const PackageNames = {
    COPO: "Copo",
    GALAO: "Galão",
    GARRAFA: "Garrafa",
    JARRA: "Jarra",
    LATA: "Lata",
    LONGNECK: "Longneck",
    OTHER: "Outro"
}

const availablePackages = [
    PackageType.COPO,
    PackageType.GALAO,
    PackageType.GARRAFA,
    PackageType.JARRA,
    PackageType.LATA,
    PackageType.LONGNECK,
    PackageType.OTHER
];

const VolumeUnit = {
    mL: "ml",
    L: "L"
}

const availableUnits = [
    VolumeUnit.mL,
    VolumeUnit.L
]

const SimpleSizeItem = ({ size, onChange }) => {
    const getTotalCharacters = () => {
        return `${size.sku?.length > 0 ? size.sku?.length : 0}/60`
    }

    const [oldPrice, setOldPrice] = useState(size.old_price || size.price)

    useEffect(() => {
        if (!size.old_price) {
          setOldPrice(size.price);
          onChange({ ...size, old_price: !size.promo_price ? null : size.price });
        } else
          setOldPrice(
            size.promo_price || (size.old_price && size.price)
              ? size.old_price
              : null
          );
      }, [size.old_price, size.promo_price]);

    return (
        <div className={styles.sizeValue}>
            <Label>Qual é o valor por tamanho?</Label>
            <div className="mb-20">
                <div className={styles.sizeName}>{size.name}</div>
            </div>
            <Input
                floatLabel="Código PDV"
                design="three"
                placeholder="----"
                className="mt-20"
                maxLength={60}
                suffix2={getTotalCharacters()}
                value={size.sku}
                onChange={(e) => {
                    onChange({ ...size, sku: e.target.value })
                }}
            />
            <div className="d-flex w-100 mt-30">
                {!size?.promo_price && !(size.old_price && size.price) && (
                    <CurrencyInput
                        design="three"
                        value={size.price}
                        onChange={(e, m, f) => {
                            onChange({ ...size, price: f })
                        }}
                        placeholder="R$ 0,00"
                        className="w-100"
                        label='Preço'
                    />
                )}
                {(!!size.promo_price || (size.old_price && size.price)) && (
                    <>
                        <CurrencyInput
                            design="three"
                            value={oldPrice}
                            onChange={(e, m, f) => {
                                onChange({ ...size, old_price: f })
                            }}
                            placeholder="R$ 0,00"
                            className="w-100"
                            label='Preço inicial'
                        />
                        <CurrencyInput
                            design="three"
                            value={size.price}
                            onChange={(e, m, f) => onChange({ ...size, price: f })}
                            placeholder="R$ 0,00"
                            className="w-100 ml-15"
                            label='Preço promocional'
                        />
                    </>
                )}
            </div>
            <Checkbox
                id={`promotion.${size.ref_id}`}
                checked={!!size.promo_price || size.old_price && size.price}
                className="mt-20"
                onChange={(e) => {
                    if (!e) onChange({ ...size, promo_price: e, price: size.old_price, old_price: null })
                    else onChange({ ...size, promo_price: e, old_price: size.old_price })
                }}
            >
                Ativar promoção
            </Checkbox>
            {/* {size.price != size.base_price && (
                <CurrencyInput
                    design="four"
                    value={size.price}
                    onChange={(e, m, f) => onChange({ ...size, price: f })}
                    placeholder="R$ 0,00"
                    className="w-50"
                />
            )} */}
        </div>
    )
}

const SizeItem = ({ size, sizeLength, onDeleteSize, onChange }) => {
    
    const getTotalCharacters = () => {
		return `${size.sku?.length > 0 ? size.sku?.length : 0}/60`
	}


    return (
        <div>
            <div className="d-flex mt-15">
                <Select
                    design="two"
                    label="Tipo de embalagem"
                    onChange={(e) => {
                        onChange && onChange({
                            ...size,
                            name: e.target.value != "Selecione uma embalagem" ? `${PackageNames[e.target.value]} - ${size.amount}${size.unit}` : null,
                            package: e.target.value != "Selecione uma embalagem" ? e.target.value : null
                        })
                    }}
                    className="flex-1"
                    value={size.package}
                    options={[
                        { label: "Selecione uma embalagem", value: null, selected: !size.package },
                        ...(availablePackages.map((p) => ({ label: PackageNames[p], value: p })))
                    ]}
                />

                {sizeLength > 1 && (
                    <Button design="default-icon-2" onClick={onDeleteSize} className="ml-15" >
                        <Icon name="trash-alt" size="lg" />
                    </Button>
                )}
            </div>

            <div className="d-flex mt-35">
                <NumberInput
                    label="Volume"
                    precision={size.unit != VolumeUnit.mL ? 1 : 0}
                    design="four"
                    placeholder="---"
                    value={size.amount}
                    onChange={(e, maskedValue, floatValue) => {
                        onChange && onChange({
                            ...size,
                            name: !!maskedValue ? `${PackageNames[size.package]} - ${e.target.value}${size.unit}` : null,
                            amount: floatValue
                        })
                    }}
                />
                <Select
                    design="two"
                    label="Medida"
                    onChange={(e) => {
                        onChange && onChange({
                            ...size,
                            name: e.target.value != "Selecione uma medida" ? `${PackageNames[size.package]} - ${size.amount}${e.target.value}` : null,
                            unit: e.target.value != "Selecione uma medida" ? e.target.value : null
                        })
                    }}
                    className="ml-15 w-100"
                    value={size.unit}
                    options={[
                        { label: "Selecione uma medida", value: null },
                        ...(availableUnits.map((u) => ({ label: u, value: u })))
                    ]}
                />
            </div>
            <div className="d-flex mt-35">
                <CurrencyInput
                    label="Valor"
                    design="four"
                    placeholder="---"
                    className="w-100"
                    value={size.price}
                    onChange={(e, maskedValue, floatValue) => {
                        onChange && onChange({
                            ...size,
                            price: floatValue
                        })
                    }}
                />
                <Input
                    floatLabel="Código PDV"
                    design="four"
                    className="w-100 ml-15"
                    placeholder="----"
                    maxLength={60}
                    value={size.sku}
                    suffix2={getTotalCharacters()}
                    onChange={(e) => {
                        console.log(e.target.value)
                        onChange({ ...size, sku: e.target.value })
                    }}
                />
            </div>
        </div>
    )
}

export class ProductDrinkSizes extends React.Component {
    state = {
        sizes: []
    }

    componentDidMount() {
        const { category, product } = this.props;
        const needsCloneCategorySizes = category.default_sizes && product.sizes.length == 0;
        this.setState({
            sizes: needsCloneCategorySizes ?
                category.sizes.map(({ id, ...size }) => size) :
                product.sizes.length == 0 ? [] : product.sizes
        })
    }

    handler(data) {
        const { product, onChange } = this.props;
        onChange && onChange({ ...product, ...data })
    }

    renderSimpleSizes() {
        const { sizes } = this.state;
        return (
            <>
                {sizes.map(s => (
                    <SimpleSizeItem
                        size={s}
                        onChange={(size) => {
                            const newSizes = sizes.map((sItem) => {
                                if (sItem.ref_id == size.ref_id) {
                                    sItem.price = size.price
                                    sItem.old_price = size.old_price;
                                    sItem.sku = size.sku;
                                    sItem.base_price = size.base_price;
                                    sItem.promo_price = size.promo_price
                                }
                                return sItem;
                            });

                            this.setState({ sizes: newSizes }, () => this.handler({
                                sizes: newSizes
                            }))
                        }}
                    />
                ))}
            </>
        )
    }

    render() {
        const { category, product } = this.props;
        const { sizes } = this.state;

        if (category.default_sizes) {
            return this.renderSimpleSizes();
        }

        return (
            <>
                <Label>Quais são os tamanhos?</Label>
                {sizes.map((size, sizeIdx, sizes) => {
                    return (
                        <>
                            <SizeItem
                                size={size}
                                key={size.ref_id}
                                sizeLength={sizes.length}
                                onChange={(size) => {
                                    sizes[sizeIdx] = size;
                                    sizes[sizeIdx].price = sizes[sizeIdx].price || 0;
                                    this.setState({ sizes }, () => this.handler({ sizes }));
                                }}
                                onDeleteSize={() => {
                                    const newSizes = sizes.filter((s) => s.ref_id != size.ref_id);
                                    this.setState({ sizes: newSizes }, () => this.handler({ sizes: newSizes }))
                                }}
                            />
                            {sizes.length > 1 && sizeIdx != (sizes.length - 1) && <Hairline />}
                        </>
                    )
                })}

                <Button design="default-2" className="w-100 mt-20" onClick={() => {
                    const newSizes = [...sizes, { name: "", type: 'size', ref_id: uuid.v4() }];
                    this.setState({ sizes: newSizes }, () => this.handler({ sizes: newSizes }))
                }}>
                    Adicionar tamanho
                </Button>

            </>
        )

    }
}
